"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _assign = _interopRequireDefault(require("lodash/assign"));

var _session = _interopRequireDefault(require("@flowio/session"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-console */
var dropRiskifiedBeacon = function dropRiskifiedBeacon(options) {
  // if the beacon already exists, do not add it again.
  var existingBeaconScriptTag = document.getElementById('flow-fraud-riskified-script');

  if (existingBeaconScriptTag !== null) {
    if (options.onSuccess) {
      options.onSuccess();
    }

    return;
  }

  var storeDomain = options.storeDomain,
      sessionId = options.sessionId; // create url for script

  var protocol = document.location.protocol === 'https:' ? 'https:' : 'http:';
  var host = 'beacon.riskified.com';
  var params = "shop=".concat(storeDomain, "&sid=").concat(sessionId);
  var url = "".concat(protocol, "//").concat(host, "?").concat(params); // create script tag

  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'flow-fraud-riskified-script';
  script.async = true;
  script.src = url; // insert script tag

  try {
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);

    if (options.onSuccess) {
      options.onSuccess();
    }
  } catch (e) {
    // Probably should replace with Raven.js
    if (console && console.log) {
      console.log('@flowio/fraud could not insert riskified script tag.');
      console.log(e);
    }
  }
};

var init = function init(options) {
  var opts = {
    storeDomain: document.location.hostname,
    sessionId: _session["default"].getVisitId()
  };
  dropRiskifiedBeacon((0, _assign["default"])({}, options, opts));
};

var _default = {
  init: init
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/lib/riskified.js
// module id = 550
// module chunks = 0 1